/**
 * 上云例外请求
 */
export default [
  '/addon/error/book/index',
  '/zhixuebao/base/common/getUserInfo',
  '/zhixuebao/report/getPageExamList',
  '/zhixuebao/report/exam/getUserExamList',
  '/zhixuebao/report/paper/getChangeTrend'
];



// WEBPACK FOOTER //
// ./src/api/cloudExcludeUrl.js